module.exports = __webpack_public_path__ + "img/icon2.c8127993.png";